<template>
  <div class="xcbdDetailCls">
    <div class="titleCls">
      <div>
        顶顶顶强调：努力打造高品质城区 让人民群众感受到实实实在在的变化和成效
      </div>
      <div class="textCls">
        <span>记者：懂滴都懂 啊啊啊</span>
        <span>通讯员：啊啊啊</span>
        <p>2023-09-13 19:45</p>
      </div>
    </div>

    <div>
      <div style="width:100%">
        <img src="@/assets/picture/111.png" alt="" width="100%" />
      </div>
      <div class="textCls">
        按实际看大家客户端卡后端接口哈花生酱的卡号的家属代好卡结婚登记卡视角花几十块的很快就爱上觉得哈加快速度假数据库大几十块的哈哈萨克打卡技术的加身就的哈加括号很简单哈数
      </div>
    </div>
    <div>
      <div style="width:100%">
        <img src="@/assets/picture/111.png" alt="" width="100%" />
      </div>
      <div class="textCls">
        按实际看大家客户端卡后端接口哈花生酱的卡号的家属代好卡结婚登记卡视角花几十块的很快就爱上觉得哈加快速度假数据库大几十块的哈哈萨克打卡技术的加身就的哈加括号很简单哈数
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'xcbdDetail',
  data() {
    return {}
  },
  props: {},
  components: {},
  created() {},
  mounted() {},
  methods: {}
}
</script>

<style scoped>
.xcbdDetailCls {
  padding: 20px;
  color: #444;
  text-align: left;
}
.titleCls div:nth-child(1) {
  font-weight: 700;
}

.textCls {
  font-size: 14px;
  color: #999;
  margin: 8px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/xcbd-detail.vue